import { render, staticRenderFns } from "./CouponsStore.vue?vue&type=template&id=cd2a6094"
import script from "./CouponsStore.vue?vue&type=script&lang=js"
export * from "./CouponsStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports